import request from 'client/utils/request'
import {
  EventInterface,
  MyEventInterface,
} from 'common/components/entities/Calendar/calendar-interface'

export function getMyEvents() {
  return request.get<MyEventInterface[]>(`/booking-calendar/event/my-events`, {
    baseURL: '/api/dashboard',
  })
}

export function getEvent(eventId: EventInterface['id']) {
  return request.get<EventInterface>(`/booking-calendar/event/${eventId}`, {
    baseURL: '/api/dashboard',
  })
}
